(() => {
  if (window.semboniaNewsletterInitialized) return;
  window.semboniaNewsletterInitialized = true;

  // These are typo checks, not a guarantee of mailbox existence or ownership.
  const domainTypos = {
    'gmial.com': 'gmail.com',
    'gamil.com': 'gmail.com',
    'gmai.com': 'gmail.com',
    'gnail.com': 'gmail.com',
    'hotmial.com': 'hotmail.com',
    'outlok.com': 'outlook.com',
    'yaho.com': 'yahoo.com'
  };

  function initialize() {
    document.querySelectorAll('.sembonia-newsletter__form').forEach((form) => {
      const input = form.querySelector('input[type="email"]');
      if (!input || form.dataset.newsletterReady) return;
      form.dataset.newsletterReady = 'true';

      function validate() {
        input.setCustomValidity('');
        const value = input.value.trim();
        if (!value || input.validity.typeMismatch) return;
        const domain = value.slice(value.lastIndexOf('@') + 1).toLowerCase();
        if (!/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/i.test(domain)) {
          input.setCustomValidity('Please enter a complete email address, such as name@example.com.');
        } else if (/\.(con|cmo|comm)$/.test(domain)) {
          input.setCustomValidity('Please check the email ending. Did you mean .com?');
        } else if (domainTypos[domain]) {
          input.setCustomValidity(`Please check the email domain. Did you mean ${domainTypos[domain]}?`);
        }
      }

      input.addEventListener('input', validate);
      input.addEventListener('change', validate);
      // Also validate autofilled values before the browser's submit validation.
      form.addEventListener('click', (event) => {
        if (event.target.closest('button[type="submit"]')) validate();
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') validate();
      });
      form.addEventListener('submit', (event) => {
        validate();
        if (!input.checkValidity()) {
          event.preventDefault();
          input.reportValidity();
        }
      });
      validate();

      // Keep Shopify's rendered confirmation visible now, but prevent a refresh
      // of the success URL from rendering it again. Preserve unrelated URL state.
      if (form.querySelector('[data-newsletter-success]')) {
        const url = new URL(window.location.href);
        if (url.searchParams.get('customer_posted') === 'true') {
          url.searchParams.delete('customer_posted');
          window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
